export default __webpack_public_path__ + "static/media/icon-coinbase.6fc17c3e.svg";